import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useFilingcredential, useFilingcredentialRef } from './state';

export function FilingCredentialsPage() {
  const ref = useFilingcredentialRef();
  const state = useFilingcredential((snapshot) => snapshot);
  const [environment, setEnvironment] = useState('production');
  const [transmitterId, setTransmitterId] = useState('');
  const registering = state.matches('registering');
  return (
    <main className="mx-auto max-w-3xl px-6 py-12 text-foreground">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Filing credentials</p>
      <h1 className="mt-3 text-3xl font-semibold tracking-tight">Register a transmitter</h1>
      <p className="mt-2 max-w-xl text-muted-foreground">
        Connect the filing environment used to submit prepared returns.
      </p>
      <div className="mt-8 grid max-w-md gap-5">
        <div className="grid gap-2">
          <Label htmlFor="environment">Environment</Label>
          <Input
            id="environment"
            data-jr-key="credential-environment"
            value={environment}
            onChange={(event) => setEnvironment(event.target.value)}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="transmitter-id">Transmitter ID</Label>
          <Input id="transmitter-id" value={transmitterId} onChange={(event) => setTransmitterId(event.target.value)} />
        </div>
        {state.matches('error') && (
          <p className="text-sm text-destructive">
            We couldn’t register this credential. Check the values and try again.
          </p>
        )}
        <Button
          data-jr-key="register-credential"
          disabled={registering}
          onClick={() => {
            if (environment.trim().length === 0 || transmitterId.trim().length === 0) return;
            ref.send({
              type: 'filingcredential.register',
              environment: environment.trim(),
              transmitterId: transmitterId.trim(),
            });
          }}
        >
          {registering ? 'Registering…' : 'Register credential'}
        </Button>
      </div>
    </main>
  );
}
